<template>
  <div class="my_add_button">
    <el-button size="small" @click="show_dialog">{{ btnText }}</el-button>
    <my_add_dialog v-if="isShow" @close="close" :type="type" @confirm="confirm" :selectIds="selectedIds" :article-type="articleType"></my_add_dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

import my_add_dialog from './my_add_dialog'
export default {
  name: 'my_add_button',
  components: {
    my_add_dialog
  },
  props: {
    type: {
      type: String,
      defalut: '',
      required: true
    },
    selectIds: {
      type: Array,
      defalut: () => []
    },
    articleType: {
      type: Number,
      default: 1
    }
  },
  computed: {
    btnText () {
      let text = ''
      if (this.type === 'goodsList') {
        text = i18n.t('components_my_add_button_index_2213')
      }
      if (this.type === 'albumList') {
        text = i18n.t('components_my_add_button_index_2214')
      }
      if (this.type === 'articleList') {
        text = i18n.t('components_my_add_button_index_2215')
      }
      if (this.type === 'testList') {
        text = i18n.t('components_my_add_button_index_2216')
      }
      if(this.type === 'jobList'){
        text = i18n.t('components_my_add_button_index_2217')
      }
      if(this.type === 'videoList'){
        text = i18n.t('components_my_add_button_index_2218')
      }
      return text
    }
  },
  watch: {
    selectIds (val) {
      this.selectedIds = val
    },
    selectedIds (val) {
      this.$emit('update:selectIds', val)
    }
  },
  data () {
    return {
      isShow: false,
      selectedIds: this.selectIds
    }
  },
  methods: {
    show_dialog () {
      this.isShow = true
    },
    close () {
      this.isShow = false
    },
    confirm (ids) {
      this.$emit('confirm', ids)
      this.isShow = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/my_add_button/index.vue